var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrop = function SvgCrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.546 2.309a.6.6 0 0 1 .6.6v3.036h8.49a2.42 2.42 0 0 1 2.419 2.418v8.49h3.037a.6.6 0 0 1 0 1.2h-3.037v3.038a.6.6 0 0 1-1.2 0v-3.037h-8.49a2.42 2.42 0 0 1-2.419-2.418V7.145H2.91a.6.6 0 0 1 0-1.2h3.037V2.908a.6.6 0 0 1 .6-.6m.6 13.327a1.22 1.22 0 0 0 1.218 1.218h8.49v-8.49a1.22 1.22 0 0 0-1.217-1.22H7.146z"
  })));
};
export default SvgCrop;